import { useLanguage } from "@/context/language-context/LanguageContext";
import literals from "@/assets/constants/literals";

export const useTranslate = () => {
  const { language } = useLanguage();

  return (
    literal: string,
    dataToInsert: string[] | undefined = undefined,
  ): string => {
    if (!literal?.trim().length) return "";
    if (literals[literal] && literals[literal][language]) {
      if (!dataToInsert) return literals[literal][language];
      const newLiteral = literals[literal] && literals[literal][language];
      return newLiteral.replace(
        /\[data{(\d+)}\]/g,
        (_, index) => dataToInsert[parseInt(index)],
      );
    }
    return literal;
  };
};
